import { DATA_LABEL_MODE, type DataLabelMode } from '../../core/Chart.types';
import { typedMemo } from '../../utils/typedMemo';
import type { ArcAngles } from './PieSlice.utils';
import { PolylineLabel } from './PolylineLabel';
import { TagLabel } from './TagLabel';

type SliceLabelProps<Datum> = {
  dataLabelMode?: DataLabelMode;
  label: string | number;
  datum: Datum;
  angles: ArcAngles;
  ringInnerRadius: number;
  ringOuterRadius: number;
  highlighted: boolean;
  selected: boolean;
  color: string;
  total?: number;
  polylineScale: number;
  visible: boolean;
};

const MemoizedPolylineLabel = typedMemo(PolylineLabel);
const MemoizedTagLabel = typedMemo(TagLabel);

export const SliceLabel = <Datum,>({
  dataLabelMode,
  label,
  datum,
  angles,
  ringInnerRadius,
  ringOuterRadius,
  highlighted,
  selected,
  color,
  total,
  polylineScale,
  visible,
}: SliceLabelProps<Datum>) => {
  if (!dataLabelMode) return null;

  if (dataLabelMode === DATA_LABEL_MODE.polyline) {
    if (!visible) return null;
    return (
      <MemoizedPolylineLabel
        datum={datum}
        angles={angles}
        ringInnerRadius={ringInnerRadius}
        ringOuterRadius={ringOuterRadius}
        highlighted={highlighted}
        selected={selected}
        color={color}
        total={total}
        scale={polylineScale}
      />
    );
  }

  return (
    <MemoizedTagLabel
      label={label}
      angles={angles}
      ringInnerRadius={ringInnerRadius}
      ringOuterRadius={ringOuterRadius}
      highlighted={highlighted}
      selected={selected}
      color={color}
    />
  );
};
